import React, { useEffect, useState } from "react";
import {
  Table,
  Box,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Switch,
  Stack,
  FormControl,
  Autocomplete,
  TextField,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Checkbox,
  FormControlLabel,
  Pagination,
  TablePagination,
  DialogActions,
  Grid,
  Tooltip,
} from "@mui/material";
import { CancelOutlined, DescriptionOutlined, FileUploadOutlined, InsertDriveFileOutlined, NoteAdd, NoteAddOutlined, PictureAsPdfOutlined } from '@mui/icons-material';
import DeleteIcon from "@mui/icons-material/Delete";
import MapIcon from "@mui/icons-material/Room";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Link, useNavigate } from "react-router-dom";
import edit from "../../../assets/images/editIcon.png";
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import {
  ApiPutVenueStatus,
  ApiGetVenueList,
  ApiGetClientEntityByClientGroupId,
  ApiQuizreTake,
  ApiGetVenuesExcel,
  ApiImportVenue,
  ApiImportSiteUsers,
} from "../../../apiService/Core/Apicall.tsx";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import store, { RootState } from "../../../global/config/store.ts";
import PatchedReactQuill from "./PatchedReactQuill.tsx";
import useDebounce from "../CreateAllocations/UseDebounce.tsx"
import { setSelectedClientGroup } from "../../../global/config/Reducer/clientSlice.ts";
import { CustomUploadProfilePic } from "../../../apiService/Core/CustomUploadProfilePic.tsx";
import { setLoadingFalse, setLoadingTrue } from "../../../global/config/Action/loadingActions.ts";
import Editor from "./Editor.tsx";
import { setclientEntityIdData } from "../../../global/config/Reducer/entitySlice.ts";


const ManageVenue: React.FC = () => {
  const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
  const selectedEntity = useSelector((state: RootState) => state.entity.clientEntityId)
  const dispatch = useDispatch()
  const [venues, setVenues] = useState<any[]>([]);
  const [status, setStatus] = useState({});
  const [clientEntityList, setClientEntityList] = useState<any>([]);
  const [clientEntityId, setClientEntityId] = useState<any>(null);
  const Clientlist = useSelector((state: RootState) => state.client.clientList);
  const [selectedClient, setSelectedClient] = useState<any>(null);
  const [ClientId, setClientId] = useState(null);
  const [OpenEditDescription, setOpenEditDescription] = useState<boolean>(false)
  const [isResetQuiz, setisResetQuiz] = useState<boolean>(false)
  const [editorValue, setEditorValue] = useState<any>("");
  const [editedvenueId, seteditedvenueId] = useState<string | number>("");
  const [editedclientEntityId, seteditedclientEntityId] = useState<number>();
  const [datalength, setdatalength] = useState<any>(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [searchText, setSearchText] = useState(sessionStorage.getItem("searchTerm") ?? "");
  const debouncedSearch = useDebounce(searchText, 500);
  const [open, setOpen] = useState(false)
  const [siteUsers, setOpenSiteUsers] = useState(false)
  const [uploadedFiles, setUploadedFiles] = useState<string[]>([]);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [uploadedFilesSite, setUploadedFilesSite] = useState<string[]>([]);
  const [selectedFilesSite, setSelectedFilesSite] = useState<File[]>([]);
  const [dialogClient, setDialogClient] = useState<any>(null);
  const [dialogClientSite, setDialogClientSite] = useState<any>(null);
  const [dialogEntityId, setDialogEntityId] = useState<any>(null);
  const [dialogEntityIdSite, setDialogEntityIdSite] = useState<any>(null);
  const [dialogEntityList, setDialogEntityList] = useState<any>([]);
  const [dialogEntityListSite, setDialogEntityListSite] = useState<any>([]);
  const [briefVenue, setBriefVenue] = useState<any[]>([]);
  const [ratingComment, setRatingComment] = useState("Thanks for completing");

  console.log("CLinet List", Clientlist)
  useEffect(() => {
    if (Clientlist.length > 2) {
      // setSelectedClient(Clientlist[2]);
      setClientId(Clientlist[2].clientGroupName);
    }
  }, [Clientlist]);

  useEffect(() => {
    setSelectedClient(selectedClientName)
  }, [selectedClientName])

  useEffect(()=>{
    setClientEntityId(selectedEntity?.value)
  },[selectedEntity])

  // useEffect(() => {
  //   if (clientEntityList.length > 0) {
  //     setClientEntityId(clientEntityList[0]?.clientEntityId);
  //   }
  // }, [clientEntityList]);

  useEffect(() => {
    if (selectedClient?.clientGroupName) {
      handleGetClientList()
    }
  }, [selectedClient?.clientGroupName])

  const handleGetClientList = async () => {
    const data = `?ClientGroupName=${selectedClientName?.clientGroupName}`;
    if (!selectedClient?.clientGroupName) return;
    try {
      const res: any = await ApiGetClientEntityByClientGroupId(data);
      setClientEntityList(res.data);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const navigate = useNavigate();

  const addOrUpdateVenue = (venue?: any) => {
    if (venue) {
      navigate(`/admin/add-or-update-venue/update/${venue?.venueId}`, {
        state: { venueData: venue },
      });
    } else {
      navigate("/admin/add-or-update-venue/add");
    }
  };

  const [isDialogOpen, setDialogOpen] = useState(false);

  const [selectedVenue, setSelectedVenue] = useState<any[]>([]);
  const handleOpenMap = (venue) => {
    setSelectedVenue(venue);
    setDialogOpen(true);
  };

  const openMapInNewTab = (venue: any) => {
    const url = "/venue-map?id=1&lat=-25.2744&lng=133.7751";
    window.open(url, "_blank"); // Open map page in a new tab
  };

  // const openMapInNewTab = (venue: any) => {
  //   const url = `https://www.google.com/maps?q=-25.2744,133.7751&z=15`;
  //   window.open(url, "_blank"); // Open map page in a new tab
  // };

  useEffect(() => {
    const fetchData = async () => {
      if (ClientId) {
        await handleGetVenueList();
      }
    };
    fetchData();
    return () => { };
  }, [clientEntityId, selectedClient, rowsPerPage, page, debouncedSearch]);

  const handleGetVenueList = async () => {
    const data =
      `?offset=${page * rowsPerPage}&limit=${rowsPerPage}` +
      (clientEntityId ? `&clientEntityId=${clientEntityId}` : '') +
      (selectedClient ? `&clientGroupName=${selectedClient.clientGroupName}` : '') +
      (debouncedSearch ? `&searchVenue=${debouncedSearch}` : '') +
      `&venueStatus=active`;
    setVenues([])
    try {
      const response: any = await ApiGetVenueList(data);
      setVenues(response.data);
      setdatalength(response.totalDataCount);
      console.log("venue list", response.data);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  useEffect(() => {
    if (editedclientEntityId) {
      const handleGetVenueListForBrief = async () => {
        const data = `?clientEntityId=${editedclientEntityId}&venueStatus=active&limit=1000`;
        setBriefVenue([])
        try {
          const response: any = await ApiGetVenueList(data);
          setBriefVenue(response.data);
          console.log("venue list", response.data);
        } catch (error) {
          console.error("Error during API call:", error);
        }
      };
      handleGetVenueListForBrief()
    }
  }, [editedclientEntityId])

  const deleteVenue = async (venue: any, newStatus: string) => {
    try {
      const body = {
        venueId: venue?.venueId,
        status: newStatus,
      };
      const response: any = await ApiPutVenueStatus(body);
      toast.success("Site Deleted successfully!");
      console.log("Status updated successfully:", response);
      handleGetVenueList();
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const navigateToViewJobCriteriaVenue = (venue?: any) => {
    navigate("/admin/view-venue-jobcriteria", {
      state: { venue },
    });
  };
  const navigateToVenueSiteQuestion = (venue?: any) => {
    // navigate("/admin/create-venue-site-template", {
    //   state: { venue },
    // });
    sessionStorage.setItem("venueQuestion", JSON.stringify({ ...venue, clientGroupName: selectedClientName }))
    const url = `/admin/create-venue-site-template`
    window.open(url, "_blank")
  };
  const navigateToVenueSiteUsers = (venue?: any) => {
    navigate("/admin/create-venue-site-users", {
      state: { venue },
    });
  };

  const navigateToViewEditors = (venue?: any) => {
    navigate("/admin/view-editor-site", {
      state: { venue },
    });
  };

  const handleChange = async (venue: any, newStatus: string) => {
    setStatus((prevStatus) => ({
      ...prevStatus,
      [venue.venueId]: newStatus,
    }));

    setVenues((prevList) =>
      prevList.map((item) =>
        item.venueId === venue.venueId
          ? {
            ...item,
            venueStatus: {
              ...item.userStatus,
              userStatus: newStatus,
            },
          }
          : item
      )
    );

    try {
      const body = {
        venueId: venue?.venueId,
        status: newStatus,
      };
      const response: any = await ApiPutVenueStatus(body);
      console.log("Status updated successfully:", response);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const quizretake = async () => {
    const data = {
      "clientEntityId": editedclientEntityId,
      "venueId": editedvenueId,
      "venueDescription": normalizeListHtml(ratingComment),
      "retakeRequired": isResetQuiz,
      "commonVenueIds": selectedVenue.join(",")
    }
    // console.log("ENd Values",)
    try {
      const response = await ApiQuizreTake(data)
      toast.success(response.message)
      handleGetVenueList()

    }
    catch (error) {
      toast.error(error)
    }
    finally {
      setOpenEditDescription(false)
    }
  }

  // ------------------------------------------- Chnage Pagination -----------------------------------------------
  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const downaloadAsExcel = async () => {
    try {

      const data = `${selectedClient ? `?clientGroupName=${selectedClient?.clientGroupName}` : ""}${clientEntityId ? `&clientEntityId=${clientEntityId}` : ""}`
      const res = await ApiGetVenuesExcel(data);

      const blob = new Blob([res], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `venuesList.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      alert(error)
    }
  };
  const handleClose = () => {
    setOpen(false);
    setUploadedFiles([]);
    setSelectedFiles([]);
  };
  const handleCloseSite = () => {
    setOpenSiteUsers(false);
    setUploadedFilesSite([]);
    setSelectedFilesSite([]);
  };

  const handleGetDialogClientEntities = async (clientGroupName: string) => {
    try {
      const data = `?ClientGroupName=${clientGroupName}`;
      const res: any = await ApiGetClientEntityByClientGroupId(data);
      setDialogEntityList(res.data);
    } catch (error) {
      console.error("Error fetching dialog client entities:", error);
    }
  };
  const handleGetDialogClientEntitiesSite = async (clientGroupName: string) => {
    try {
      const data = `?ClientGroupName=${clientGroupName}`;
      const res: any = await ApiGetClientEntityByClientGroupId(data);
      setDialogEntityListSite(res.data);
    } catch (error) {
      console.error("Error fetching dialog client entities:", error);
    }
  };

  // const uploadFile = async (
  //   file: File,
  //   fileType: string = "project_static_files"
  // ): Promise<string | undefined> => {
  //   try {
  //     store.dispatch(setLoadingTrue());
  //     const userId = localStorage.getItem("userId")
  //     const formData = new FormData();
  //     formData.append("file", file);
  //     formData.append("fileType", fileType);
  //     formData.append("userId", userId ?? "");

  //     const response = await CustomUploadProfilePic(formData);

  //     setUploadedFiles((prev: string[]) => [...prev, response.location]);
  //     setSelectedFiles((prev: File[]) => prev.filter((f) => f !== file));

  //     toast.success("File uploaded successfully");
  //     return response.location;
  //   } catch (error: any) {
  //     console.error("Error uploading file:", error);
  //     toast.error(error?.response?.data?.message || "Failed to upload file");
  //     throw error;
  //   } finally {
  //     store.dispatch(setLoadingFalse());
  //   }
  // };


  // const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const files = event.target.files;
  //   if (!files) return;

  //   const newFiles = Array.from(files);
  //   setSelectedFiles(prev => [...prev, ...newFiles]);

  //   for (const file of newFiles) {
  //     try {
  //       await uploadFile(file, "project_static_files");
  //     } catch (error) {
  //       console.error("File upload failed:", error);
  //     }
  //   }

  //   event.target.value = '';
  // };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      setSelectedFiles(Array.from(files));
    }
  };

  const handleFileChangeSite = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      setSelectedFilesSite(Array.from(files));
    }
  };

  const handleImportVenue = async () => {
    if (!dialogEntityId || selectedFiles.length === 0) {
      toast.error("Please select a client entity and upload a file");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("clientEntityId", dialogEntityId);
      formData.append("file", selectedFiles[0]);

      store.dispatch(setLoadingTrue());
      await ApiImportVenue(formData);

      toast.success("Sites imported successfully!");
      handleClose();
      handleGetVenueList();
    } catch (error: any) {
      console.error("Import failed:", error);
      toast.error(error?.response?.data?.message || "Failed to import sites");
    } finally {
      store.dispatch(setLoadingFalse());
    }
  };

  const handleRemoveFile = (index: number, isUploaded: boolean = true) => {
    if (isUploaded) {
      setUploadedFiles(prev => {
        const updatedFiles = [...prev];
        updatedFiles.splice(index, 1);
        return updatedFiles;
      });
    } else {
      setSelectedFiles(prev => {
        const updatedFiles = [...prev];
        updatedFiles.splice(index, 1);
        return updatedFiles;
      });
    }
  };

  const handleRemoveFileSite = (index: number, isUploaded: boolean = true) => {
    if (isUploaded) {
      setUploadedFilesSite(prev => {
        const updatedFiles = [...prev];
        updatedFiles.splice(index, 1);
        return updatedFiles;
      });
    } else {
      setSelectedFilesSite(prev => {
        const updatedFiles = [...prev];
        updatedFiles.splice(index, 1);
        return updatedFiles;
      });
    }
  };

  const handleImportVenueSite = async () => {
    if (!dialogEntityIdSite || selectedFilesSite.length === 0) {
      toast.error("Please select a client entity and upload a file");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("clientEntityId", dialogEntityIdSite);
      formData.append("file", selectedFilesSite[0]);

      store.dispatch(setLoadingTrue());
      await ApiImportSiteUsers(formData);

      toast.success("Sites imported successfully!");
      handleCloseSite();
      handleGetVenueList();
    } catch (error: any) {
      console.error("Import failed:", error);
      toast.error(error?.response?.data?.message || "Failed to import sites");
    } finally {
      store.dispatch(setLoadingFalse());
    }
  };

  const normalizeListHtml = (html: string): string => {
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, "text/html")
  
    // Convert Quill list structure to semantic UL/OL
    const listItems = doc.querySelectorAll("li")
  
    listItems.forEach((li) => {
      const listType = li.getAttribute("data-list")
      const parent = li.parentElement
  
      if (!parent || !listType) return
  
      // Remove Quill-specific attribute
      li.removeAttribute("data-list")
  
      if (listType === "bullet") {
        if (parent.tagName.toLowerCase() === "ol") {
          const ul = doc.createElement("ul")
  
          // Copy existing attributes if any
          Array.from(parent.attributes).forEach((attr) => {
            ul.setAttribute(attr.name, attr.value)
          })
  
          parent.parentNode?.replaceChild(ul, parent)
  
          // Move all li elements into UL
          Array.from(parent.children).forEach((child) => {
            ul.appendChild(child)
          })
        }
      }
  
      if (listType === "ordered") {
        if (parent.tagName.toLowerCase() === "ul") {
          const ol = doc.createElement("ol")
  
          Array.from(parent.attributes).forEach((attr) => {
            ol.setAttribute(attr.name, attr.value)
          })
  
          parent.parentNode?.replaceChild(ol, parent)
  
          Array.from(parent.children).forEach((child) => {
            ol.appendChild(child)
          })
        }
      }
    })
  
    // Remove any remaining Quill-specific list attributes/classes
    doc.querySelectorAll("li").forEach((li) => {
      li.removeAttribute("data-list")
      li.classList.remove("ql-indent-1", "ql-indent-2", "ql-indent-3")
    })
  
    return doc.body.innerHTML
  }
  return (
    <div className="w-100 px-2 py-0 py-md-3">
      <Box className='w-100 border-10 bg-white p-2 py-5'>
        <Grid container gap={2} className=" align-items-center w-100  mb-5">
          <Grid size={{ xs: 12, md: "auto" }} order={{ xs: 2, md: 1 }}>
            <Stack className="d-flex  align-items-start " flexWrap={'wrap'} gap={{ xs: 2, md: 1 }} width={'fit-content'} direction="row" >
              <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                <Autocomplete
                  disablePortal
                  id="mm-autocomplete"
                  options={Clientlist}
                  value={selectedClient}
                  getOptionLabel={(option) => option?.clientGroupName}
                  isOptionEqualToValue={(option, value) =>
                    option.clientGroupDBName === value.clientGroupDBName
                  }
                  onChange={(event, newValue: any) => {
                    // setSelectedClient(newValue);
                    dispatch(setSelectedClientGroup(newValue))
                    setClientId(newValue?.clientGroupName || null);

                    // if (!newValue || (selectedClient && newValue.clientGroupName !== selectedClient.clientGroupName)) {
                    // setClientEntityId(null)
                    dispatch(setclientEntityIdData(null))
                    setClientEntityList([])
                    // }
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Select Client" />
                  )}
                  size="small"
                />
              </FormControl>
              <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                <Autocomplete
                  disablePortal
                  id="beacon-autocomplete"
                  options={clientEntityList.filter(
                    (item) => item.clientEntityId !== null
                  )} // filter out invalid entries
                  getOptionLabel={(option) => option?.entityName || ""} // properly show label
                  onChange={(event, newValue: any) => {
                    const data ={label: newValue?.entityName,value:newValue?.clientEntityId,regions:newValue?.regions}
                    dispatch(setclientEntityIdData(data))
                    // setClientEntityId(newValue?.clientEntityId || null);
                  }}
                  value={
                    clientEntityList.find(
                      (option) => option?.clientEntityId === clientEntityId
                    ) || null
                  }
                  // defaultValue={clientEntityList[0]?.clientEntityId}
                  renderInput={(params) => (
                    <TextField {...params} label="Select Business" />
                  )}
                  size="small"
                />
              </FormControl>
              <FormControl size="small" sx={{ width: { xs: "100%", md: 250 } }}>
                <TextField
                  label="Search Sites"
                  size="small"
                  value={searchText}
                  onChange={(e) => {setSearchText(e.target.value); sessionStorage.setItem("searchTerm",e.target.value)}}
                />
              </FormControl>
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, md: "grow" }} order={{ xs: 1, md: 2 }}>
            <h1 style={{ textAlign: "center" }}>Manage Sites</h1>
          </Grid>
          <Grid size={{ xs: 12, md: 4, xl: 'auto' }} justifyContent={'end'} order={{ xs: 3, md: 3 }}>
            <Grid
              container
              spacing={2}
              alignItems={'center'}
              wrap="wrap"
              sx={{
                width: "100%",
                justifyContent: { xs: "space-between", md: "flex-end" }
              }}
            >
              <Grid size={{ xs: 6, md: "auto" }}>
                {/* <Button
                  variant="contained"
                  onClick={() => {
                    window.open(
                      "https://s3.ap-southeast-2.amazonaws.com/mmfiles/ProjectFiles/79ba1c2b-cb5b-440e-b872-eb66b2757b30-bulk_venue_upload_template.xlsx",
                      "_blank"
                    );
                  }}
                  className="table-row-background fs-14"
                  fullWidth
                >
                  Export Template
                </Button> */}
                <Button
                  variant="contained"
                  onClick={() => setOpenSiteUsers(true)}
                  className="table-row-background fs-14"
                  fullWidth
                >
                  Import Site Users
                </Button>
              </Grid>

              <Grid size={{ xs: 6, md: "auto" }}>
                <Button
                  variant="contained"
                  onClick={() => setOpen(true)}
                  className="table-row-background fs-14"
                  fullWidth
                >
                  Import Sites
                </Button>
              </Grid>

              <Grid size={{ xs: 6, md: "auto" }}>
                <Button
                  variant="contained"
                  onClick={() => downaloadAsExcel()}
                  className="table-row-background fs-14"
                  fullWidth
                >
                  Export As Excel
                </Button>
              </Grid>

              <Grid size={{ xs: 6, md: "auto" }}>
                <Link
                  to={"/admin/add-or-update-venue/add"}
                  // variant="contained"
                  // onClick={() => addOrUpdateVenue()}
                  className="table-row-background link-btn"
                >
                  Add New Site
                </Link>
              </Grid>
            </Grid>

          </Grid>
        </Grid>
        <Box className='w-100' overflow={'auto'}>
          <Table>
            <TableHead>
              <TableRow className="table-row-background">
                {/* <TableCell style={{ color: "#fff" }}>XLS</TableCell> */}
                <TableCell style={{ color: "#fff" }}>Site Name</TableCell>
                <TableCell style={{ color: "#fff" }}>Site Code</TableCell>
                <TableCell style={{ color: "#fff" }}>State</TableCell>
                <TableCell style={{ color: "#fff", paddingLeft: "50px" }}>
                  Editor
                </TableCell>
                <TableCell style={{ color: "#fff", paddingLeft: "35px" }}>
                  Job Criteria
                </TableCell>
                <TableCell style={{ color: "#fff", paddingLeft: "35px" }}>
                  Questions
                </TableCell>
                 <TableCell style={{ color: "#fff", paddingLeft: "35px" }}>Users</TableCell>
                <TableCell style={{ color: "#fff", paddingLeft: "35px" }}>Staff Member</TableCell>
                <TableCell style={{ color: "#fff", paddingLeft: "35px" }}>Brief</TableCell>
                <TableCell style={{ color: "#fff" }}>Active</TableCell>
                {/* <TableCell style={{ color: "#fff" }}>Copy Brief</TableCell>
            <TableCell style={{ color: "#fff" }}></TableCell> */}
                <TableCell style={{ color: "#fff" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {venues.map((venue) => (
                <TableRow key={venue.id}>
                  {/* <TableCell>
                <Button variant="contained" className="table-row-background">
                  {" "}
                  Upload
                </Button>
              </TableCell> */}
                  <TableCell>{venue.venueName}</TableCell>
                  <TableCell>{venue.venueCode}</TableCell>
                  <TableCell>{venue.state}</TableCell>
                  <TableCell>
                    <Link
                      to={`/admin/view-editor-site/${venue?.venueId}`}
                      // onClick={() => navigateToViewEditors(venue)}
                      className="table-row-background link-btn fs-14"
                    >
                      View Editors
                    </Link>
                  </TableCell>
                  <TableCell>
                    <Link
                      to={`/admin/view-venue-jobcriteria/${venue?.venueId}`}
                      // onClick={() => navigateToViewEditors(venue)}
                      className="table-row-background link-btn fs-14"
                    >
                      Job Criteria
                    </Link>
                    {/* <Button
                    variant="contained"
                    onClick={() => navigateToViewJobCriteriaVenue(venue)}
                    className="table-row-background fs-14"
                  >
                    Job Criteria
                  </Button> */}
                  </TableCell>
                  <TableCell>
                    <Link
                      to={`/admin/create-venue-site-template/${venue?.venueId}`}
                      // onClick={() => navigateToVenueSiteQuestion(venue)}
                      className="table-row-background fs-14 link-btn"
                    >
                      Questions
                    </Link>
                    {/* <Button
                    variant="contained"
                    onClick={() => navigateToVenueSiteQuestion(venue)}
                    className="table-row-background fs-14"
                  >
                    Questions
                  </Button> */}
                  </TableCell>
                  <TableCell>
                    <Link
                      to={`/admin/create-venue-site-users/${venue?.venueId}`}
                      // onClick={() => navigateToViewEditors(venue)}
                      className="table-row-background link-btn fs-14"
                    >
                      Users
                    </Link>
                    {/* <Button
                    variant="contained"
                    onClick={() => navigateToVenueSiteUsers(venue)}
                    className="table-row-background fs-14"
                  >
                    Users
                  </Button> */}
                  </TableCell>
                  <TableCell>
                    <Link
                      to={`/admin/create-venue-site-staff/${venue?.venueId}`}
                      // onClick={() => navigateToViewEditors(venue)}
                      className="table-row-background link-btn fs-14"
                    >
                      Staff Member
                    </Link>
                    {/* <Button
                    variant="contained"
                    onClick={() => navigateToVenueSiteUsers(venue)}
                    className="table-row-background fs-14"
                  >
                    Users
                  </Button> */}
                  </TableCell>
                  <TableCell>
                    <Link
                      to={`/admin/manage-venue-brief/${venue?.venueId}`}
                      className="table-row-background link-btn fs-14"
                    >
                      Brief
                    </Link>
                  </TableCell>
                  <TableCell>
                    <div className="switch-admin">
                      <Switch
                        checked={venue?.venueStatus?.userStatus === "active"}
                        onChange={(e) => {
                          const newStatus = e.target.checked
                            ? "active"
                            : "inActive";
                          handleChange(venue, newStatus); // Pass the store and the new status
                        }}
                        sx={{
                          '& .MuiSwitch-thumb': {
                            backgroundColor: venue?.venueStatus?.userStatus === "active" ? "#1976d2" : "#ccc !important"
                          },
                          '& .MuiSwitch-track': {
                            backgroundColor: venue?.venueStatus?.userStatus === "active" ? "#90caf9" : "#ccc"
                          }
                        }}
                        inputProps={{ "aria-label": "controlled" }}
                      />{" "}
                    </div>
                  </TableCell>
                  <TableCell className="d-flex align-items-center justify-content-start">
                    <Tooltip title='brief'>
                      <IconButton onClick={() => { setOpenEditDescription(true); if (venue) { setRatingComment(venue.venueDescription); seteditedvenueId(venue.venueId); seteditedclientEntityId(venue.clientEntityId.clientEntityId) } }} >
                        <NoteAddOutlined sx={{ color: "#75724C" }} />
                      </IconButton>
                    </Tooltip>
                    <Link
                      to={`/admin/add-or-update-venue/update/${venue?.venueId}`}
                    // variant="contained"
                    // className="table-row-background"
                    // onClick={() => addOrUpdateVenue(venue)}
                    >
                      <Box component="img" className="w-75" src={edit}></Box>
                    </Link>
                    {/* <Button
                    // variant="contained"
                    // className="table-row-background"
                    onClick={() => addOrUpdateVenue(venue)}
                  >
                    <Box component="img" className="w-50" src={edit}></Box>
                  </Button> */}
                    <Button
                      variant="contained"
                      className="delete-transparent"
                      onClick={() => {
                        const isConfirmed = window.confirm(
                          "Are you sure you want to delete the Site?"
                        );
                        if (isConfirmed) {
                          deleteVenue(venue, "delete"); // Call the API or action
                        }
                      }}
                    >
                      <DeleteIcon className="delete-icon" />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={datalength}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
      {/* -----------------------------------------------------------------Edit Description --------------------------- */}

      <Dialog open={OpenEditDescription}
        PaperProps={{
          sx: {
            width: '900px',
            height: 'fit-content',
            maxWidth: 'none'
          }
        }}
      >
        <DialogContent className="p-3 d-flex flex-column gap-5">
          <Box className='d-flex align-items-center justify-content-between'>
            <Typography className="fw-bold" variant="h5">Update Job Description</Typography>
            <IconButton onClick={() => { setOpenEditDescription(false); setSelectedVenue([]); }}>
              <CancelOutlinedIcon />
            </IconButton>
          </Box>
          <Box className='mt-3'>
            {/* <PatchedReactQuill
              setEditorValue={setEditorValue}
              editorValue={editorValue}
              isUpdate={false}
            /> */}
            <Editor
              setValue={setRatingComment}
              value={ratingComment}
              isUpdate={false}
            />
          </Box>
          {/* <FormControlLabel className="my-1 mt-2" control={<Checkbox checked={isResetQuiz} onChange={() => { setisResetQuiz(!isResetQuiz) }} />} label="Reset quiz for this business" /> */}
          <FormControl sx={{ marginTop: 2, mb: 2 }}>
            <Autocomplete
              multiple
              id="venue-autocomplete"
              options={[{ venueId: "all", venueName: "Select All" }, ...briefVenue]}
              disableCloseOnSelect
              value={briefVenue.filter((option: any) =>
                selectedVenue.includes(option.venueId)
              )}
              getOptionLabel={(option: any) => option.venueName}
              onChange={(event, newValue: any[]) => {
                const isSelectAll = newValue.some((v: any) => v.venueId === "all");

                if (isSelectAll) {
                  if (selectedVenue.length === briefVenue.length) {
                    setSelectedVenue([]);
                  } else {
                    setSelectedVenue(briefVenue.map((v: any) => v.venueId));
                  }
                } else {
                  const venueIds = newValue.map((v: any) => v.venueId);
                  setSelectedVenue(venueIds);
                }
              }}
              renderOption={(props, option: any) => {
                const isAll = option.venueId === "all";
                const checked = isAll
                  ? selectedVenue.length === briefVenue.length
                  : selectedVenue.includes(option.venueId);

                return (
                  <li {...props}>
                    <Checkbox
                      checked={checked}
                      style={{ marginRight: 8 }}
                    />
                    {option.venueName}
                  </li>
                );
              }}
              renderInput={(params) => (
                <TextField {...params} label="Select Sites" />
              )}
              size="small"
            />
          </FormControl>
          <Button variant="contained" onClick={quizretake}
            className="table-row-background my-1 mx-auto" sx={{ width: 'fit-content', textTransform: 'none' }}>Submit</Button>
        </DialogContent>
      </Dialog>
      <Dialog open={open} onClose={handleClose} PaperProps={{
        sx: {
          width: '900px',
          height: 'fit-content',
          maxWidth: 'none'
        }
      }}>
        <DialogContent>
          <Typography variant="h6" gutterBottom>
            Import Sites
          </Typography>

          <FormControl fullWidth size="small" className="mb-3">
            <Autocomplete
              disablePortal
              options={Clientlist}
              value={dialogClient}
              getOptionLabel={(option) => option?.clientGroupName || ""}
              isOptionEqualToValue={(option, value) =>
                option.clientGroupDBName === value.clientGroupDBName
              }
              onChange={(event, newValue: any) => {
                setDialogClient(newValue);
                setDialogEntityId(null);
                setDialogEntityList([]);
                if (newValue?.clientGroupName) {
                  handleGetDialogClientEntities(newValue.clientGroupName);
                }
              }}

              renderInput={(params) => (
                <TextField {...params} label="Select Client" />
              )}
            />
          </FormControl>

          <FormControl fullWidth size="small" className="mb-3">
            <Autocomplete
              disablePortal
              options={dialogEntityList.filter((item) => item.clientEntityId !== null)}
              getOptionLabel={(option) => option?.entityName || ""}
              value={
                dialogEntityList.find((option) => option?.clientEntityId === dialogEntityId) || null
              }
              onChange={(event, newValue: any) =>
                setDialogEntityId(newValue?.clientEntityId || null)
              }
              renderInput={(params) => (
                <TextField {...params} label="Select Business" />
              )}
            />
          </FormControl>

          {/* <FormControl className='mt-3' fullWidth>
            <Grid container className='w-100' spacing={2}>
              {uploadedFiles.map((fileUrl, index) => (
                <Grid size={12} key={index}>
                  <Box
                  className='w-100'
                    sx={{
                      position: 'relative',
                      border: '1px solid',
                      borderRadius: '20px',
                      overflow: 'hidden',
                      height: '150px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      p: 2
                    }}
                  >
                    {fileUrl.includes(".pdf") ? (
                      <PictureAsPdfOutlined color="error" fontSize="large" />
                    ) : fileUrl.includes(".xlsx") || fileUrl.includes(".xls") ? (
                      <DescriptionOutlined color="success" fontSize="large" />
                    ) : (
                      <InsertDriveFileOutlined color="action" fontSize="large" />
                    )}

                    <Typography variant="body2" noWrap sx={{ maxWidth: '100%', mt: 1 }}>
                      {fileUrl.split('/').pop()}
                    </Typography>

                    <IconButton
                      onClick={() => handleRemoveFile(index, true)}
                      sx={{
                        position: 'absolute',
                        top: 5,
                        right: 5,
                        bgcolor: 'white',
                        '&:hover': { bgcolor: 'grey.100' },
                      }}
                    >
                      <CancelOutlinedIcon color="error" />
                    </IconButton>
                  </Box>
                </Grid>
              ))}

             {uploadedFiles.length < 1 && (<Grid size={12}>
                <label htmlFor="file-upload" className="w-100" style={{ fontSize: '14px', color: 'grey' }}>
                  Upload Files
                  <Box
                    className="mt-2 w-100 d-flex align-items-center justify-content-center"
                    height={150}
                    border="1px dashed #00000033"
                    borderRadius={5}
                  >
                    <input
                      type="file"
                      id="file-upload"
                      accept=".pdf,.xlsx,.xls,.doc,.docx,.txt,.csv"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                      multiple
                    />
                    <Box className="d-flex flex-column align-items-center justify-content-center">
                      <Box className="border-blue" borderRadius="10px">
                        <FileUploadOutlined fontSize="medium" className="text-blue" />
                      </Box>
                      <Typography variant="caption">Upload Here</Typography>
                    </Box>
                  </Box>
                </label>
              </Grid>
              ) } 
            </Grid>
          </FormControl> */}
          <FormControl className='mt-3' fullWidth>
            <Grid container className='w-100' spacing={2}>
              {selectedFiles.map((file, index) => (
                <Grid size={12} key={index}>
                  <Box
                    className='w-100'
                    sx={{
                      position: 'relative',
                      border: '1px solid',
                      borderRadius: '20px',
                      overflow: 'hidden',
                      height: '150px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      p: 2
                    }}
                  >
                    {file.name.endsWith(".pdf") ? (
                      <PictureAsPdfOutlined color="error" fontSize="large" />
                    ) : file.name.endsWith(".xlsx") || file.name.endsWith(".xls") ? (
                      <DescriptionOutlined color="success" fontSize="large" />
                    ) : (
                      <InsertDriveFileOutlined color="action" fontSize="large" />
                    )}

                    <Typography variant="body2" noWrap sx={{ maxWidth: '100%', mt: 1 }}>
                      {file.name}
                    </Typography>

                    <IconButton
                      onClick={() => handleRemoveFile(index, false)}
                      sx={{
                        position: 'absolute',
                        top: 5,
                        right: 5,
                        bgcolor: 'white',
                        '&:hover': { bgcolor: 'grey.100' },
                      }}
                    >
                      <CancelOutlinedIcon color="error" />
                    </IconButton>
                  </Box>
                </Grid>
              ))}

              {selectedFiles.length < 1 && (
                <Grid size={12}>
                  <label htmlFor="file-upload" className="w-100" style={{ fontSize: '14px', color: 'grey' }}>
                    Upload Files
                    <Box
                      className="mt-2 w-100 d-flex align-items-center justify-content-center"
                      height={150}
                      border="1px dashed #00000033"
                      borderRadius={5}
                    >
                      <input
                        type="file"
                        id="file-upload"
                        accept=".pdf,.xlsx,.xls,.doc,.docx,.txt,.csv"
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                        multiple
                      />
                      <Box className="d-flex flex-column align-items-center justify-content-center">
                        <Box className="border-blue" borderRadius="10px">
                          <FileUploadOutlined fontSize="medium" className="text-blue" />
                        </Box>
                        <Typography variant="caption">Upload Here</Typography>
                      </Box>
                    </Box>
                  </label>
                </Grid>
              )}
            </Grid>
          </FormControl>

          <DialogActions>
            <Stack direction="row" spacing={2} justifyContent="flex-end" mt={3}>
              <Button
                variant="contained"
                onClick={() => handleClose()}
                className="table-row-background "
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={() => handleImportVenue()}
                className="table-row-background "
              >
                Submit
              </Button>
            </Stack>
          </DialogActions>
        </DialogContent>
      </Dialog>
      <Dialog open={siteUsers} onClose={handleCloseSite} PaperProps={{
        sx: {
          width: '900px',
          height: 'fit-content',
          maxWidth: 'none'
        }
      }}>
        <DialogContent>
          <Typography variant="h6" gutterBottom>
            Import Site Users
          </Typography>

          <FormControl fullWidth size="small" className="mb-3">
            <Autocomplete
              disablePortal
              options={Clientlist}
              value={dialogClientSite}
              getOptionLabel={(option) => option?.clientGroupName || ""}
              isOptionEqualToValue={(option, value) =>
                option.clientGroupDBName === value.clientGroupDBName
              }
              onChange={(event, newValue: any) => {
                setDialogClientSite(newValue);
                setDialogEntityIdSite(null);
                setDialogEntityListSite([]);
                if (newValue?.clientGroupName) {
                  handleGetDialogClientEntitiesSite(newValue.clientGroupName);
                }
              }}

              renderInput={(params) => (
                <TextField {...params} label="Select Client" />
              )}
            />
          </FormControl>

          <FormControl fullWidth size="small" className="mb-3">
            <Autocomplete
              disablePortal
              options={dialogEntityListSite.filter((item) => item.clientEntityId !== null)}
              getOptionLabel={(option) => option?.entityName || ""}
              value={
                dialogEntityListSite.find((option) => option?.clientEntityId === dialogEntityIdSite) || null
              }
              onChange={(event, newValue: any) =>
                setDialogEntityIdSite(newValue?.clientEntityId || null)
              }
              renderInput={(params) => (
                <TextField {...params} label="Select Business" />
              )}
            />
          </FormControl>
          <FormControl className='mt-3' fullWidth>
            <Grid container className='w-100' spacing={2}>
              {selectedFilesSite.map((file, index) => (
                <Grid size={12} key={index}>
                  <Box
                    className='w-100'
                    sx={{
                      position: 'relative',
                      border: '1px solid',
                      borderRadius: '20px',
                      overflow: 'hidden',
                      height: '150px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      p: 2
                    }}
                  >
                    {file.name.endsWith(".pdf") ? (
                      <PictureAsPdfOutlined color="error" fontSize="large" />
                    ) : file.name.endsWith(".xlsx") || file.name.endsWith(".xls") ? (
                      <DescriptionOutlined color="success" fontSize="large" />
                    ) : (
                      <InsertDriveFileOutlined color="action" fontSize="large" />
                    )}

                    <Typography variant="body2" noWrap sx={{ maxWidth: '100%', mt: 1 }}>
                      {file.name}
                    </Typography>

                    <IconButton
                      onClick={() => handleRemoveFileSite(index, false)}
                      sx={{
                        position: 'absolute',
                        top: 5,
                        right: 5,
                        bgcolor: 'white',
                        '&:hover': { bgcolor: 'grey.100' },
                      }}
                    >
                      <CancelOutlinedIcon color="error" />
                    </IconButton>
                  </Box>
                </Grid>
              ))}

              {selectedFilesSite.length < 1 && (
                <Grid size={12}>
                  <label htmlFor="file-upload" className="w-100" style={{ fontSize: '14px', color: 'grey' }}>
                    Upload Files
                    <Box
                      className="mt-2 w-100 d-flex align-items-center justify-content-center"
                      height={150}
                      border="1px dashed #00000033"
                      borderRadius={5}
                    >
                      <input
                        type="file"
                        id="file-upload"
                        accept=".pdf,.xlsx,.xls,.doc,.docx,.txt,.csv"
                        style={{ display: "none" }}
                        onChange={handleFileChangeSite}
                        multiple
                      />
                      <Box className="d-flex flex-column align-items-center justify-content-center">
                        <Box className="border-blue" borderRadius="10px">
                          <FileUploadOutlined fontSize="medium" className="text-blue" />
                        </Box>
                        <Typography variant="caption">Upload Here</Typography>
                      </Box>
                    </Box>
                  </label>
                </Grid>
              )}
            </Grid>
          </FormControl>

          <DialogActions>
            <Stack direction="row" spacing={2} justifyContent="flex-end" mt={3}>
              <Button
                variant="contained"
                onClick={() => handleCloseSite()}
                className="table-row-background "
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={() => handleImportVenueSite()}
                className="table-row-background "
              >
                Submit
              </Button>
            </Stack>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ManageVenue;
